module.exports = __webpack_public_path__ + "static/Keith Crim-88db404f9c603cd6219ee1c1a08f0e3e.png";